/**
 * Generates a base64 Data URI
 * @param mimeType The mime type for the data e.g. image/png
 * @param encodedData The data to form the URI with
 * @param charSet Optional charset e.g utf-8
 */
export function getBase64DataUri(mimeType, encodedData, charSet) {
    var dataPart = "data:".concat(mimeType, ";");
    var charSetPart = charSet ? "charset=".concat(charSet, ";") : '';
    return "".concat(dataPart).concat(charSetPart, "base64,").concat(encodedData);
}
//# sourceMappingURL=getBase64DataUri.js.map